import { render, staticRenderFns } from "./ShowEvent.vue?vue&type=template&id=3fb45f56"
import script from "./ShowEvent.vue?vue&type=script&lang=js"
export * from "./ShowEvent.vue?vue&type=script&lang=js"
import style0 from "./ShowEvent.vue?vue&type=style&index=0&id=3fb45f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports